import { render, staticRenderFns } from "./dgoodsInfo.vue?vue&type=template&id=1d6ec5ba&scoped=true&"
import script from "./dgoodsInfo.vue?vue&type=script&lang=js&"
export * from "./dgoodsInfo.vue?vue&type=script&lang=js&"
import style0 from "./dgoodsInfo.vue?vue&type=style&index=0&id=1d6ec5ba&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d6ec5ba",
  null
  
)

export default component.exports